import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { formatUnixDateTime } from '@/shared/lib/datetime';
import { getListRows, getTotalPages } from '@/shared/lib/pagination';
import { fetchUserBilling, type BillingOperation } from './api';
import { PagedBox } from './PagedBox';

interface BillingRow extends Record<string, unknown> {
  id: number;
  comment?: string | null;
  create_time?: number;
  amount?: number | string;
}

const TITLES: Record<BillingOperation, string> = {
  refill: 'История пополнений',
  spending: 'История списаний',
};

export const UserBillingBox = ({ userId, operation }: { userId: string | number; operation: BillingOperation }) => {
  const [page, setPage] = useState(1);
  const { data, isLoading, error } = useQuery({
    queryKey: ['user', String(userId), 'billing', operation, page],
    queryFn: () => fetchUserBilling(userId, operation, page),
  });
  const rows = getListRows<BillingRow>(data, ['items']);

  return (
    <PagedBox
      title={TITLES[operation]}
      isLoading={isLoading}
      error={error}
      page={page}
      totalPages={getTotalPages(data)}
      onPageChange={setPage}
    >
      <table className="table table-bordered">
        <thead>
          <tr>
            <th>id</th>
            <th>Комментарии</th>
            <th>Дата создания</th>
            <th>Сумма</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((row) => (
            <tr key={row.id}>
              <td>{row.id}</td>
              <td>{row.comment || 'No comment'}</td>
              <td>{formatUnixDateTime(row.create_time)}</td>
              <td>{row.amount}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </PagedBox>
  );
};
